import script from "./News.vue?vue&type=script&lang=ts&setup=true"
export * from "./News.vue?vue&type=script&lang=ts&setup=true"

import "./News.vue?vue&type=style&index=0&id=c4f72566&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4f72566"]])

export default __exports__